import http from './http';
import { ITheme } from '../resource/interfaces';

// Get all themes
export const getThemes = async (): Promise<{ success: boolean; themes: ITheme[]; msg?: string }> => {
  try {
    const response = await http.get('/themes');
    return { success: true, themes: response };
  } catch (error: any) {
    return { success: false, themes: [], msg: error.msg || 'Failed to fetch themes' };
  }
};

// Get theme by ID
export const getTheme = async (id: string): Promise<{ success: boolean; theme?: ITheme; msg?: string }> => {
  try {
    const response = await http.get(`/themes/${id}`);
    return { success: true, theme: response };
  } catch (error: any) {
    return { success: false, msg: error.msg || 'Failed to fetch theme' };
  }
};

// Create new theme
export const createTheme = async (theme: Omit<ITheme, '_id' | 'createdAt' | 'updatedAt'>): Promise<{ success: boolean; theme?: ITheme; msg?: string }> => {
  try {
    const response = await http.post('/themes', theme);
    return { success: true, theme: response };
  } catch (error: any) {
    return { success: false, msg: error.msg || 'Failed to create theme' };
  }
};

// Update theme
export const updateTheme = async (id: string, theme: Partial<ITheme>): Promise<{ success: boolean; theme?: ITheme; msg?: string }> => {
  try {
    const response = await http.put(`/themes/${id}`, theme);
    return { success: true, theme: response };
  } catch (error: any) {
    return { success: false, msg: error.msg || 'Failed to update theme' };
  }
};

// Delete theme
export const deleteTheme = async (id: string): Promise<{ success: boolean; msg?: string }> => {
  try {
    await http.delete(`/themes/${id}`);
    return { success: true };
  } catch (error: any) {
    return { success: false, msg: error.msg || 'Failed to delete theme' };
  }
};

// Set theme as active
export const setActiveTheme = async (id: string): Promise<{ success: boolean; msg?: string }> => {
  try {
    await http.patch(`/themes/${id}/activate`);
    return { success: true };
  } catch (error: any) {
    return { success: false, msg: error.msg || 'Failed to activate theme' };
  }
};
